export const impEn = {
  'dat.imp.eyebrow': 'Catalogue',
  'dat.imp.title': 'Import records',
  'dat.imp.description': 'Bring in MARC or CSV files. Review matches against your catalogue before anything is saved, and revert a batch if you change your mind.',
  'dat.imp.tab.wizard': 'Import',
  'dat.imp.tab.batches': 'Batches',
  'dat.imp.tab.rules': 'Rules',
  'dat.imp.step.upload': 'Upload',
  'dat.imp.step.review': 'Review',
  'dat.imp.step.commit': 'Import',
  'dat.imp.step.done': 'Done',
  'dat.imp.file.title': 'Choose a file',
  'dat.imp.file.description': 'ISO 2709 (.mrc), MARCXML (.xml) or CSV. The format is detected from the file name.',
  'dat.imp.file.drop': 'Drop a file here or browse',
  'dat.imp.file.hint': '.mrc, .xml or .csv, up to 200 MB',
  'dat.imp.file.remove': 'Remove file',
  'dat.imp.file.readFailed': 'We could not read the start of this file to preview its columns.',
  'dat.imp.format.label': 'File format',
  'dat.imp.format.ISO2709': 'ISO 2709',
  'dat.imp.format.MARCXML': 'MARCXML',
  'dat.imp.format.CSV': 'CSV',
  'dat.imp.format.detected': 'Detected: {format}',
  'dat.imp.format.unknown': 'We could not tell the format from the file name. Choose one.',
  'dat.imp.csv.title': 'Map CSV columns',
  'dat.imp.csv.description': '{count} columns found, {mapped} mapped. We guessed from the header names; check them.',
  'dat.imp.csv.reset': 'Reset guesses',
  'dat.imp.csv.column': 'CSV column',
  'dat.imp.csv.sample': 'Sample values',
  'dat.imp.csv.target': 'Import as',
  'dat.imp.csv.skip': 'Do not import',
  'dat.imp.csv.guess': 'Guess',
  'dat.imp.csv.unnamed': 'Column {n}',
  'dat.imp.csv.mapColumn': 'Map column {column}',
  'dat.imp.csv.duplicate': '{field} is mapped from more than one column ({headers}). Map it once.',
  'dat.imp.csv.noHeaders': 'This CSV file has no header row, so columns cannot be mapped.',
  'dat.imp.options.title': 'Import options',
  'dat.imp.options.description': 'How records are matched against the catalogue and what happens to each kind of record.',
  'dat.imp.options.name': 'Batch name',
  'dat.imp.options.nameHint': 'Shown in the list of previous batches.',
  'dat.imp.options.framework': 'MARC framework',
  'dat.imp.options.frameworkHint': 'Used for new records.',
  'dat.imp.options.frameworkDefault': 'Default framework',
  'dat.imp.options.rule': 'Match rule',
  'dat.imp.options.ruleHint': 'Decides which incoming records count as already in the catalogue.',
  'dat.imp.options.ruleNone': 'No matching',
  'dat.imp.options.matchAction': 'When a record matches',
  'dat.imp.options.matchActionHint': 'Needs a match rule unless you ignore matches.',
  'dat.imp.options.nomatchAction': 'When nothing matches',
  'dat.imp.options.itemAction': 'Items in the file',
  'dat.imp.matchAction.IGNORE': 'Ignore the incoming record',
  'dat.imp.matchAction.REPLACE': 'Replace the existing record',
  'dat.imp.matchAction.ADD_ITEMS': 'Keep the record, add items only',
  'dat.imp.nomatchAction.CREATE': 'Create a new record',
  'dat.imp.nomatchAction.IGNORE': 'Ignore the incoming record',
  'dat.imp.itemAction.ADD': 'Add items',
  'dat.imp.itemAction.REPLACE': 'Replace existing items',
  'dat.imp.itemAction.IGNORE': 'Do not import items',
  'dat.imp.block.NO_FILE': 'Choose a file to continue.',
  'dat.imp.block.NO_FORMAT': 'Choose the file format to continue.',
  'dat.imp.block.NO_MAPPING': 'The CSV columns could not be read.',
  'dat.imp.block.DUPLICATE_FIELD': 'Each field can be mapped from only one column.',
  'dat.imp.block.TOO_LARGE': 'This file is larger than the 200 MB limit.',
  'dat.imp.rule.thresholdShort': 'threshold {value}',
  'dat.imp.stage.submit': 'Stage and review',
  'dat.imp.stage.running': 'Reading and matching',
  'dat.imp.stage.failed': 'The file could not be staged',
  'dat.imp.review.title': 'Review staged records',
  'dat.imp.review.summary': '{total} records in the file, {ready} ready to import.',
  'dat.imp.review.all': 'All',
  'dat.imp.review.filter': 'Filter records by status',
  'dat.imp.review.search': 'Search title, author or ISBN',
  'dat.imp.review.rematchRule': 'Match rule for re-matching',
  'dat.imp.review.rematch': 'Re-match',
  'dat.imp.review.rematched': 'Re-matched: {matched} of {total} records matched.',
  'dat.imp.review.parseErrors': '{count} records in the file could not be read',
  'dat.imp.review.parseErrorsHint': 'They were left out of this batch. The rest can still be imported.',
  'dat.imp.review.emptyTitle': 'No records here',
  'dat.imp.review.emptyDesc': 'Nothing matches this filter. Try another status or clear the search.',
  'dat.imp.review.startOver': 'Start over',
  'dat.imp.review.continue': 'Continue to import',
  'dat.imp.review.nothingToImport': 'No records are ready to import.',
  'dat.imp.status.STAGED': 'Staged',
  'dat.imp.status.MATCHED': 'Matched',
  'dat.imp.status.IMPORTED': 'Imported',
  'dat.imp.status.IGNORED': 'Ignored',
  'dat.imp.status.ERROR': 'Error',
  'dat.imp.col.title': 'Record',
  'dat.imp.col.status': 'Status',
  'dat.imp.col.match': 'Matches',
  'dat.imp.col.items': 'Items',
  'dat.imp.untitled': '(no title)',
  'dat.imp.score': 'score {score}',
  'dat.imp.action.preview': 'Preview record {n}',
  'dat.imp.action.changeMatch': 'Change match for record {n}',
  'dat.imp.action.ignore': 'Ignore record {n}',
  'dat.imp.action.include': 'Include record {n} again',
  'dat.imp.preview.title': 'Staged record',
  'dat.imp.preview.description': 'The MARC record and items exactly as they will be imported.',
  'dat.imp.preview.matched': 'Matches catalogue record #{id} (score {score})',
  'dat.imp.preview.imported': 'Imported as record #{id}',
  'dat.imp.preview.errors': 'Problems with this record',
  'dat.imp.preview.items': 'Items ({count})',
  'dat.imp.preview.noItems': 'No items came with this record.',
  'dat.imp.preview.item': 'Item {n}',
  'dat.imp.match.title': 'Change matched record',
  'dat.imp.match.id': 'Catalogue record number',
  'dat.imp.match.hint': 'The number shown in the record URL. Clearing the match makes this a new record.',
  'dat.imp.match.invalid': 'Enter a record number, for example 42.',
  'dat.imp.match.save': 'Save match',
  'dat.imp.match.clear': 'Clear match',
  'dat.imp.commit.title': 'Import settings',
  'dat.imp.commit.description': '{count} records will be processed. Nothing is saved until you confirm.',
  'dat.imp.commit.defaultLibrary': 'Default library',
  'dat.imp.commit.defaultLibraryHint': 'For items that do not name a library.',
  'dat.imp.commit.defaultItemType': 'Default item type',
  'dat.imp.commit.defaultItemTypeHint': 'For items that do not name an item type.',
  'dat.imp.commit.noDefault': 'No default',
  'dat.imp.commit.createMissing': 'Create missing reference values',
  'dat.imp.commit.createMissingHint': 'Add item types, locations and collections named in the file that do not exist yet.',
  'dat.imp.commit.submit': 'Import {count} records',
  'dat.imp.commit.retry': 'Try again',
  'dat.imp.commit.progressTitle': 'Import progress',
  'dat.imp.commit.queued': 'Waiting to start',
  'dat.imp.commit.running': 'Importing records',
  'dat.imp.commit.progressCount': '{done} of {total} records processed',
  'dat.imp.commit.failed': 'The import did not finish',
  'dat.imp.commit.lost': 'We lost contact with the import job. Check the list of previous batches before trying again.',
  'dat.imp.done.title': 'Import complete',
  'dat.imp.done.description': 'The records are in the catalogue.',
  'dat.imp.done.created': 'Created',
  'dat.imp.done.replaced': 'Replaced',
  'dat.imp.done.itemsAdded': 'Items added',
  'dat.imp.done.ignored': 'Ignored',
  'dat.imp.done.errors': 'Errors',
  'dat.imp.done.noSummary': 'This batch was imported earlier. Its counts are in the list of previous batches.',
  'dat.imp.done.viewCatalogue': 'Open catalogue',
  'dat.imp.done.another': 'Import another file',
  'dat.imp.revert.open': 'Revert this import',
  'dat.imp.revert.title': 'Revert this import?',
  'dat.imp.revert.desc': 'Records and items created by this batch are removed and replaced records are restored. Records that have loans or holds cannot be reverted.',
  'dat.imp.revert.confirm': 'Revert import',
  'dat.imp.revert.doneTitle': 'Import reverted',
  'dat.imp.revert.doneDesc': '{count} records were reverted.',
  'dat.imp.revert.partial': '{reverted} reverted, {failed} could not be reverted.',
  'dat.imp.revert.failedTitle': '{count} records could not be reverted',
  'dat.imp.revert.failedHint': 'These stay in the catalogue. Fix the cause and revert again.',
  'dat.imp.revert.record': 'Record {id}',
  'dat.imp.revertReason.ITEMS_HAVE_CIRCULATION_HISTORY': 'Its items have loan history',
  'dat.imp.revertReason.BIBLIO_IN_USE': 'It has loans or holds',
  'dat.imp.revertReason.REVERT_FAILED': 'Unexpected error',
  'dat.imp.batches.title': 'Previous batches',
  'dat.imp.batches.filter': 'Filter batches by status',
  'dat.imp.batches.allStatuses': 'All statuses',
  'dat.imp.batches.emptyTitle': 'No batches yet',
  'dat.imp.batches.emptyDesc': 'Batches appear here after you stage a file. Staged batches can be resumed.',
  'dat.imp.batchStatus.STAGED': 'Staged',
  'dat.imp.batchStatus.COMMITTED': 'Imported',
  'dat.imp.batchStatus.REVERTED': 'Reverted',
  'dat.imp.batchStatus.ERROR': 'Error',
  'dat.imp.batch.name': 'Batch',
  'dat.imp.batch.format': 'Format',
  'dat.imp.batch.records': 'Imported / total',
  'dat.imp.batch.created': 'Created',
  'dat.imp.batch.open': 'Open {name}',
  'dat.imp.batch.revert': 'Revert {name}',
  'dat.imp.batch.delete': 'Delete {name}',
  'dat.imp.batch.deleteTitle': 'Delete this batch?',
  'dat.imp.batch.deleteDesc': 'The staged data of "{name}" is removed.',
  'dat.imp.batch.deleteCommitted': 'Only the staging data is removed. The records already imported stay in the catalogue. Revert the batch first to remove them.',
  'dat.imp.batch.deleted': 'Batch deleted',
  'dat.imp.rules.title': 'Match rules',
  'dat.imp.rules.description': 'A rule scores each incoming record against the catalogue. Records reaching the threshold count as matches.',
  'dat.imp.rules.emptyTitle': 'No match rules',
  'dat.imp.rules.emptyDesc': 'Create a rule, for example ISBN worth 100 points with a threshold of 100.',
  'dat.imp.rule.new': 'New rule',
  'dat.imp.rule.newTitle': 'New match rule',
  'dat.imp.rule.editTitle': 'Edit match rule',
  'dat.imp.rule.formDescription': 'Each match point adds its score when the field matches. Title, author and publisher compare by similarity.',
  'dat.imp.rule.code': 'Code',
  'dat.imp.rule.codeHint': 'Letters, digits, dot, dash and underscore.',
  'dat.imp.rule.name': 'Name',
  'dat.imp.rule.thresholdLabel': 'Threshold',
  'dat.imp.rule.thresholdHint': 'Score needed to count as a match. Highest possible: {max}.',
  'dat.imp.rule.threshold': 'Threshold {value}',
  'dat.imp.rule.matchpoints': 'Match points',
  'dat.imp.rule.field': 'Field',
  'dat.imp.rule.score': 'Score',
  'dat.imp.rule.similarity': 'Similarity',
  'dat.imp.rule.addPoint': 'Add match point',
  'dat.imp.rule.removePoint': 'Remove {field} match point',
  'dat.imp.rule.edit': 'Edit {name}',
  'dat.imp.rule.delete': 'Delete {name}',
  'dat.imp.rule.deleteTitle': 'Delete this match rule?',
  'dat.imp.rule.deleteDesc': '"{name}" will be removed. Batches that used it keep their results.',
  'dat.imp.rule.deleted': 'Match rule deleted',
  'dat.imp.rule.saved': 'Match rule saved',
  'dat.imp.rule.err.CODE_REQUIRED': 'Enter a code.',
  'dat.imp.rule.err.CODE_FORMAT': 'Use letters, digits, dot, dash or underscore only.',
  'dat.imp.rule.err.NAME_REQUIRED': 'Enter a name.',
  'dat.imp.rule.err.THRESHOLD_RANGE': 'The threshold must be a whole number from 1 to 10000.',
  'dat.imp.rule.err.NO_MATCHPOINTS': 'Add at least one match point.',
  'dat.imp.rule.err.DUPLICATE_FIELD': 'Each field can be used once.',
  'dat.imp.rule.err.SCORE_RANGE': 'Scores must be from 1 to 1000.',
  'dat.imp.rule.err.SIMILARITY_RANGE': 'Similarity must be from 0.1 to 1.',
  'dat.imp.rule.err.UNREACHABLE_THRESHOLD': 'The match points add up to less than the threshold, so nothing could ever match.',
} as const;

export const impHi: Record<keyof typeof impEn, string> = {
  'dat.imp.eyebrow': 'सूची',
  'dat.imp.title': 'रिकॉर्ड आयात करें',
  'dat.imp.description': 'MARC या CSV फ़ाइलें लाएँ। कुछ भी सहेजने से पहले सूची से मिलान की समीक्षा करें, और मन बदलने पर बैच वापस करें।',
  'dat.imp.tab.wizard': 'आयात',
  'dat.imp.tab.batches': 'बैच',
  'dat.imp.tab.rules': 'नियम',
  'dat.imp.step.upload': 'अपलोड',
  'dat.imp.step.review': 'समीक्षा',
  'dat.imp.step.commit': 'आयात',
  'dat.imp.step.done': 'पूर्ण',
  'dat.imp.file.title': 'फ़ाइल चुनें',
  'dat.imp.file.description': 'ISO 2709 (.mrc), MARCXML (.xml) या CSV। प्रारूप फ़ाइल के नाम से पहचाना जाता है।',
  'dat.imp.file.drop': 'फ़ाइल यहाँ छोड़ें या ब्राउज़ करें',
  'dat.imp.file.hint': '.mrc, .xml या .csv, 200 MB तक',
  'dat.imp.file.remove': 'फ़ाइल हटाएँ',
  'dat.imp.file.readFailed': 'कॉलम का पूर्वावलोकन दिखाने के लिए हम फ़ाइल की शुरुआत नहीं पढ़ सके।',
  'dat.imp.format.label': 'फ़ाइल प्रारूप',
  'dat.imp.format.ISO2709': 'ISO 2709',
  'dat.imp.format.MARCXML': 'MARCXML',
  'dat.imp.format.CSV': 'CSV',
  'dat.imp.format.detected': 'पहचाना गया: {format}',
  'dat.imp.format.unknown': 'फ़ाइल के नाम से प्रारूप पता नहीं चला। एक चुनें।',
  'dat.imp.csv.title': 'CSV कॉलम मैप करें',
  'dat.imp.csv.description': '{count} कॉलम मिले, {mapped} मैप हुए। हमने हेडर नामों से अनुमान लगाया है; उन्हें जाँचें।',
  'dat.imp.csv.reset': 'अनुमान रीसेट करें',
  'dat.imp.csv.column': 'CSV कॉलम',
  'dat.imp.csv.sample': 'नमूना मान',
  'dat.imp.csv.target': 'इस रूप में आयात',
  'dat.imp.csv.skip': 'आयात न करें',
  'dat.imp.csv.guess': 'अनुमान',
  'dat.imp.csv.unnamed': 'कॉलम {n}',
  'dat.imp.csv.mapColumn': 'कॉलम {column} मैप करें',
  'dat.imp.csv.duplicate': '{field} एक से अधिक कॉलम ({headers}) से मैप है। इसे एक बार मैप करें।',
  'dat.imp.csv.noHeaders': 'इस CSV फ़ाइल में हेडर पंक्ति नहीं है, इसलिए कॉलम मैप नहीं हो सकते।',
  'dat.imp.options.title': 'आयात विकल्प',
  'dat.imp.options.description': 'रिकॉर्ड सूची से कैसे मिलाए जाते हैं और हर प्रकार के रिकॉर्ड का क्या होता है।',
  'dat.imp.options.name': 'बैच का नाम',
  'dat.imp.options.nameHint': 'पिछले बैचों की सूची में दिखता है।',
  'dat.imp.options.framework': 'MARC फ़्रेमवर्क',
  'dat.imp.options.frameworkHint': 'नए रिकॉर्ड के लिए उपयोग होता है।',
  'dat.imp.options.frameworkDefault': 'डिफ़ॉल्ट फ़्रेमवर्क',
  'dat.imp.options.rule': 'मिलान नियम',
  'dat.imp.options.ruleHint': 'तय करता है कि कौन से आने वाले रिकॉर्ड सूची में पहले से माने जाएँ।',
  'dat.imp.options.ruleNone': 'कोई मिलान नहीं',
  'dat.imp.options.matchAction': 'रिकॉर्ड मेल खाने पर',
  'dat.imp.options.matchActionHint': 'मिलान अनदेखा न करें तो मिलान नियम चाहिए।',
  'dat.imp.options.nomatchAction': 'कुछ मेल न खाने पर',
  'dat.imp.options.itemAction': 'फ़ाइल के आइटम',
  'dat.imp.matchAction.IGNORE': 'आने वाला रिकॉर्ड अनदेखा करें',
  'dat.imp.matchAction.REPLACE': 'मौजूदा रिकॉर्ड बदलें',
  'dat.imp.matchAction.ADD_ITEMS': 'रिकॉर्ड रखें, केवल आइटम जोड़ें',
  'dat.imp.nomatchAction.CREATE': 'नया रिकॉर्ड बनाएँ',
  'dat.imp.nomatchAction.IGNORE': 'आने वाला रिकॉर्ड अनदेखा करें',
  'dat.imp.itemAction.ADD': 'आइटम जोड़ें',
  'dat.imp.itemAction.REPLACE': 'मौजूदा आइटम बदलें',
  'dat.imp.itemAction.IGNORE': 'आइटम आयात न करें',
  'dat.imp.block.NO_FILE': 'आगे बढ़ने के लिए फ़ाइल चुनें।',
  'dat.imp.block.NO_FORMAT': 'आगे बढ़ने के लिए फ़ाइल प्रारूप चुनें।',
  'dat.imp.block.NO_MAPPING': 'CSV कॉलम पढ़े नहीं जा सके।',
  'dat.imp.block.DUPLICATE_FIELD': 'हर फ़ील्ड केवल एक कॉलम से मैप हो सकता है।',
  'dat.imp.block.TOO_LARGE': 'यह फ़ाइल 200 MB की सीमा से बड़ी है।',
  'dat.imp.rule.thresholdShort': 'सीमा {value}',
  'dat.imp.stage.submit': 'स्टेज करें और समीक्षा करें',
  'dat.imp.stage.running': 'पढ़ रहे हैं और मिला रहे हैं',
  'dat.imp.stage.failed': 'फ़ाइल स्टेज नहीं हो सकी',
  'dat.imp.review.title': 'स्टेज किए रिकॉर्ड की समीक्षा',
  'dat.imp.review.summary': 'फ़ाइल में {total} रिकॉर्ड, {ready} आयात के लिए तैयार।',
  'dat.imp.review.all': 'सभी',
  'dat.imp.review.filter': 'स्थिति से रिकॉर्ड फ़िल्टर करें',
  'dat.imp.review.search': 'शीर्षक, लेखक या ISBN खोजें',
  'dat.imp.review.rematchRule': 'पुनः मिलान के लिए मिलान नियम',
  'dat.imp.review.rematch': 'फिर से मिलाएँ',
  'dat.imp.review.rematched': 'पुनः मिलान: {total} में से {matched} रिकॉर्ड मिले।',
  'dat.imp.review.parseErrors': 'फ़ाइल के {count} रिकॉर्ड पढ़े नहीं जा सके',
  'dat.imp.review.parseErrorsHint': 'उन्हें इस बैच से बाहर रखा गया है। बाकी आयात किए जा सकते हैं।',
  'dat.imp.review.emptyTitle': 'यहाँ कोई रिकॉर्ड नहीं',
  'dat.imp.review.emptyDesc': 'इस फ़िल्टर से कुछ मेल नहीं खाता। दूसरी स्थिति आज़माएँ या खोज हटाएँ।',
  'dat.imp.review.startOver': 'फिर से शुरू करें',
  'dat.imp.review.continue': 'आयात पर आगे बढ़ें',
  'dat.imp.review.nothingToImport': 'कोई रिकॉर्ड आयात के लिए तैयार नहीं है।',
  'dat.imp.status.STAGED': 'स्टेज किया',
  'dat.imp.status.MATCHED': 'मिलान हुआ',
  'dat.imp.status.IMPORTED': 'आयात हुआ',
  'dat.imp.status.IGNORED': 'अनदेखा',
  'dat.imp.status.ERROR': 'त्रुटि',
  'dat.imp.col.title': 'रिकॉर्ड',
  'dat.imp.col.status': 'स्थिति',
  'dat.imp.col.match': 'मिलान',
  'dat.imp.col.items': 'आइटम',
  'dat.imp.untitled': '(शीर्षक नहीं)',
  'dat.imp.score': 'स्कोर {score}',
  'dat.imp.action.preview': 'रिकॉर्ड {n} का पूर्वावलोकन',
  'dat.imp.action.changeMatch': 'रिकॉर्ड {n} का मिलान बदलें',
  'dat.imp.action.ignore': 'रिकॉर्ड {n} अनदेखा करें',
  'dat.imp.action.include': 'रिकॉर्ड {n} फिर शामिल करें',
  'dat.imp.preview.title': 'स्टेज किया रिकॉर्ड',
  'dat.imp.preview.description': 'MARC रिकॉर्ड और आइटम ठीक वैसे जैसे आयात होंगे।',
  'dat.imp.preview.matched': 'सूची रिकॉर्ड #{id} से मेल (स्कोर {score})',
  'dat.imp.preview.imported': 'रिकॉर्ड #{id} के रूप में आयात हुआ',
  'dat.imp.preview.errors': 'इस रिकॉर्ड की समस्याएँ',
  'dat.imp.preview.items': 'आइटम ({count})',
  'dat.imp.preview.noItems': 'इस रिकॉर्ड के साथ कोई आइटम नहीं आया।',
  'dat.imp.preview.item': 'आइटम {n}',
  'dat.imp.match.title': 'मिलान किया रिकॉर्ड बदलें',
  'dat.imp.match.id': 'सूची रिकॉर्ड संख्या',
  'dat.imp.match.hint': 'रिकॉर्ड URL में दिखने वाली संख्या। मिलान हटाने पर यह नया रिकॉर्ड बनता है।',
  'dat.imp.match.invalid': 'रिकॉर्ड संख्या दर्ज करें, जैसे 42।',
  'dat.imp.match.save': 'मिलान सहेजें',
  'dat.imp.match.clear': 'मिलान हटाएँ',
  'dat.imp.commit.title': 'आयात सेटिंग',
  'dat.imp.commit.description': '{count} रिकॉर्ड संसाधित होंगे। पुष्टि करने तक कुछ सहेजा नहीं जाता।',
  'dat.imp.commit.defaultLibrary': 'डिफ़ॉल्ट पुस्तकालय',
  'dat.imp.commit.defaultLibraryHint': 'उन आइटम के लिए जिनमें पुस्तकालय का नाम नहीं है।',
  'dat.imp.commit.defaultItemType': 'डिफ़ॉल्ट आइटम प्रकार',
  'dat.imp.commit.defaultItemTypeHint': 'उन आइटम के लिए जिनमें आइटम प्रकार नहीं है।',
  'dat.imp.commit.noDefault': 'कोई डिफ़ॉल्ट नहीं',
  'dat.imp.commit.createMissing': 'अनुपस्थित संदर्भ मान बनाएँ',
  'dat.imp.commit.createMissingHint': 'फ़ाइल में बताए वे आइटम प्रकार, स्थान और संग्रह जोड़ें जो अभी मौजूद नहीं हैं।',
  'dat.imp.commit.submit': '{count} रिकॉर्ड आयात करें',
  'dat.imp.commit.retry': 'फिर कोशिश करें',
  'dat.imp.commit.progressTitle': 'आयात की प्रगति',
  'dat.imp.commit.queued': 'शुरू होने की प्रतीक्षा',
  'dat.imp.commit.running': 'रिकॉर्ड आयात हो रहे हैं',
  'dat.imp.commit.progressCount': '{total} में से {done} रिकॉर्ड संसाधित',
  'dat.imp.commit.failed': 'आयात पूरा नहीं हुआ',
  'dat.imp.commit.lost': 'आयात कार्य से संपर्क टूट गया। फिर कोशिश करने से पहले पिछले बैचों की सूची जाँचें।',
  'dat.imp.done.title': 'आयात पूर्ण',
  'dat.imp.done.description': 'रिकॉर्ड अब सूची में हैं।',
  'dat.imp.done.created': 'बनाए',
  'dat.imp.done.replaced': 'बदले',
  'dat.imp.done.itemsAdded': 'जोड़े गए आइटम',
  'dat.imp.done.ignored': 'अनदेखे',
  'dat.imp.done.errors': 'त्रुटियाँ',
  'dat.imp.done.noSummary': 'यह बैच पहले आयात हो चुका है। इसकी गिनती पिछले बैचों की सूची में है।',
  'dat.imp.done.viewCatalogue': 'सूची खोलें',
  'dat.imp.done.another': 'दूसरी फ़ाइल आयात करें',
  'dat.imp.revert.open': 'यह आयात वापस करें',
  'dat.imp.revert.title': 'यह आयात वापस करें?',
  'dat.imp.revert.desc': 'इस बैच से बने रिकॉर्ड और आइटम हटा दिए जाते हैं और बदले गए रिकॉर्ड बहाल होते हैं। जिन रिकॉर्ड पर ऋण या होल्ड हैं वे वापस नहीं हो सकते।',
  'dat.imp.revert.confirm': 'आयात वापस करें',
  'dat.imp.revert.doneTitle': 'आयात वापस किया गया',
  'dat.imp.revert.doneDesc': '{count} रिकॉर्ड वापस किए गए।',
  'dat.imp.revert.partial': '{reverted} वापस हुए, {failed} वापस नहीं हो सके।',
  'dat.imp.revert.failedTitle': '{count} रिकॉर्ड वापस नहीं हो सके',
  'dat.imp.revert.failedHint': 'ये सूची में बने रहते हैं। कारण ठीक करके फिर वापस करें।',
  'dat.imp.revert.record': 'रिकॉर्ड {id}',
  'dat.imp.revertReason.ITEMS_HAVE_CIRCULATION_HISTORY': 'इसके आइटम का ऋण इतिहास है',
  'dat.imp.revertReason.BIBLIO_IN_USE': 'इस पर ऋण या होल्ड हैं',
  'dat.imp.revertReason.REVERT_FAILED': 'अनपेक्षित त्रुटि',
  'dat.imp.batches.title': 'पिछले बैच',
  'dat.imp.batches.filter': 'स्थिति से बैच फ़िल्टर करें',
  'dat.imp.batches.allStatuses': 'सभी स्थितियाँ',
  'dat.imp.batches.emptyTitle': 'अभी कोई बैच नहीं',
  'dat.imp.batches.emptyDesc': 'फ़ाइल स्टेज करने के बाद बैच यहाँ दिखते हैं। स्टेज किए बैच फिर से शुरू किए जा सकते हैं।',
  'dat.imp.batchStatus.STAGED': 'स्टेज किया',
  'dat.imp.batchStatus.COMMITTED': 'आयात हुआ',
  'dat.imp.batchStatus.REVERTED': 'वापस किया',
  'dat.imp.batchStatus.ERROR': 'त्रुटि',
  'dat.imp.batch.name': 'बैच',
  'dat.imp.batch.format': 'प्रारूप',
  'dat.imp.batch.records': 'आयात / कुल',
  'dat.imp.batch.created': 'बनाया गया',
  'dat.imp.batch.open': '{name} खोलें',
  'dat.imp.batch.revert': '{name} वापस करें',
  'dat.imp.batch.delete': '{name} हटाएँ',
  'dat.imp.batch.deleteTitle': 'यह बैच हटाएँ?',
  'dat.imp.batch.deleteDesc': '"{name}" का स्टेज किया डेटा हटा दिया जाएगा।',
  'dat.imp.batch.deleteCommitted': 'केवल स्टेजिंग डेटा हटता है। आयात हो चुके रिकॉर्ड सूची में रहते हैं। उन्हें हटाने के लिए पहले बैच वापस करें।',
  'dat.imp.batch.deleted': 'बैच हटाया गया',
  'dat.imp.rules.title': 'मिलान नियम',
  'dat.imp.rules.description': 'नियम हर आने वाले रिकॉर्ड को सूची के विरुद्ध अंक देता है। सीमा तक पहुँचने वाले रिकॉर्ड मेल माने जाते हैं।',
  'dat.imp.rules.emptyTitle': 'कोई मिलान नियम नहीं',
  'dat.imp.rules.emptyDesc': 'एक नियम बनाएँ, जैसे ISBN के 100 अंक और सीमा 100।',
  'dat.imp.rule.new': 'नया नियम',
  'dat.imp.rule.newTitle': 'नया मिलान नियम',
  'dat.imp.rule.editTitle': 'मिलान नियम संपादित करें',
  'dat.imp.rule.formDescription': 'फ़ील्ड मेल खाने पर हर मिलान बिंदु अपना स्कोर जोड़ता है। शीर्षक, लेखक और प्रकाशक समानता से तुलना होते हैं।',
  'dat.imp.rule.code': 'कोड',
  'dat.imp.rule.codeHint': 'अक्षर, अंक, बिंदु, डैश और अंडरस्कोर।',
  'dat.imp.rule.name': 'नाम',
  'dat.imp.rule.thresholdLabel': 'सीमा',
  'dat.imp.rule.thresholdHint': 'मेल मानने के लिए ज़रूरी स्कोर। अधिकतम संभव: {max}।',
  'dat.imp.rule.threshold': 'सीमा {value}',
  'dat.imp.rule.matchpoints': 'मिलान बिंदु',
  'dat.imp.rule.field': 'फ़ील्ड',
  'dat.imp.rule.score': 'स्कोर',
  'dat.imp.rule.similarity': 'समानता',
  'dat.imp.rule.addPoint': 'मिलान बिंदु जोड़ें',
  'dat.imp.rule.removePoint': '{field} मिलान बिंदु हटाएँ',
  'dat.imp.rule.edit': '{name} संपादित करें',
  'dat.imp.rule.delete': '{name} हटाएँ',
  'dat.imp.rule.deleteTitle': 'यह मिलान नियम हटाएँ?',
  'dat.imp.rule.deleteDesc': '"{name}" हटा दिया जाएगा। जिन बैचों ने इसे उपयोग किया उनके परिणाम बने रहेंगे।',
  'dat.imp.rule.deleted': 'मिलान नियम हटाया गया',
  'dat.imp.rule.saved': 'मिलान नियम सहेजा गया',
  'dat.imp.rule.err.CODE_REQUIRED': 'कोड दर्ज करें।',
  'dat.imp.rule.err.CODE_FORMAT': 'केवल अक्षर, अंक, बिंदु, डैश या अंडरस्कोर उपयोग करें।',
  'dat.imp.rule.err.NAME_REQUIRED': 'नाम दर्ज करें।',
  'dat.imp.rule.err.THRESHOLD_RANGE': 'सीमा 1 से 10000 के बीच पूर्ण संख्या होनी चाहिए।',
  'dat.imp.rule.err.NO_MATCHPOINTS': 'कम से कम एक मिलान बिंदु जोड़ें।',
  'dat.imp.rule.err.DUPLICATE_FIELD': 'हर फ़ील्ड एक बार उपयोग हो सकता है।',
  'dat.imp.rule.err.SCORE_RANGE': 'स्कोर 1 से 1000 के बीच होने चाहिए।',
  'dat.imp.rule.err.SIMILARITY_RANGE': 'समानता 0.1 से 1 के बीच होनी चाहिए।',
  'dat.imp.rule.err.UNREACHABLE_THRESHOLD': 'मिलान बिंदुओं का योग सीमा से कम है, इसलिए कभी कोई मेल नहीं होगा।',
};
